export default ({ store }, inject) => {
  inject('flags', {
    isActive: tag => store.getters['flag/isActive'](tag)
  })
}